"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionName = void 0;
var InteractionName;
(function (InteractionName) {
    InteractionName["WIDGET_LOAD"] = "widget-load-common";
    InteractionName["WIDGET_LOAD_BY"] = "widget-load-by";
    InteractionName["UPDATE_COUNTRY"] = "update-country";
    InteractionName["RESOLVE_COUNTRY"] = "resolve-country";
    InteractionName["LAZY_COMPONENT_LOAD"] = "lazy-component-load";
    InteractionName["MOUNT_TO_LOADER"] = "mount-to-loader";
    InteractionName["ALE"] = "load";
    InteractionName["ALE_LAZY_MOUNT_TO_LOADER"] = "load-phase-loader";
    InteractionName["ALE_LOADER_TO_PARTIAL_RENDER"] = "load-phase-partial-render";
    InteractionName["ALE_PARTIAL_TO_FULL_RENDER"] = "load-phase-full-render";
    InteractionName["FRAMED_MODAL_ALE"] = "framed-modal-load";
    InteractionName["FRAMED_MODAL_ALE_LOADER"] = "framed-modal-load-phase-loader";
    InteractionName["FRAMED_MODAL_ALE_RENDER"] = "framed-modal-load-phase-render";
    InteractionName["PAY_MODAL_ALE"] = "pay-modal-load";
    InteractionName["SQUARE_3DS_MODAL_MOUNT"] = "square-3ds-modal-mount";
    InteractionName["INSTANT_PAYMENT_MODAL_MOUNT"] = "instant-modal-modal-mount";
    InteractionName["SQUARE_CASH_APP_PAGE_INIT"] = "square-cash-app-page-init";
    InteractionName["SQUARE_CASH_APP_PAGE_TOKENIZATION"] = "square-cash-app-page-tokenization";
    InteractionName["INIT_SDK"] = "init-sdk";
    InteractionName["LOAD_SETTINGS"] = "load-settings";
    InteractionName["INIT_BI"] = "init-bi";
    InteractionName["LOAD_ZDP_SCRIPT"] = "load-zdp-script";
    InteractionName["SETUP_ZERO_CHARGE_ORDER"] = "setup-zero-charge-order";
    InteractionName["FIND_AGREEMENT_ID"] = "find-agreement-id";
    InteractionName["CAPTCHA_LOAD_AND_RENDER"] = "captcha-load-and-render";
    InteractionName["CAPTCHA_SDK_LOAD"] = "captcha-sdk-load";
    InteractionName["CAPTCHA_SDK_READY"] = "captcha-sdk-ready";
    InteractionName["CAPTCHA_SECONDARY_RENDER"] = "captcha-secondary-render";
})(InteractionName = exports.InteractionName || (exports.InteractionName = {}));
//# sourceMappingURL=InteractionName.js.map